// Internal modules
import { logger } from '@/lib/logger';

/// TODO - Remove this file during clean up of the old CRS implementation

type FptiPayload = {
  optsel?: string;
  selectedOption?: string;
  transition_name?: string;
  total_tax_residencies?: number;
  int_error_code?: string;
  int_error_desc?: string;
};
const getFptiPayload = (
  payload: FptiPayload,
): FptiPayload & {
  state_name: 'crs_section';
} => {
  return {
    state_name: 'crs_section',
    ...payload,
  };
};

export const logCrsTaxStatusSelection = (taxStatus: string): void => {
  logger.fpti(
    'crs_tax_status',
    getFptiPayload({
      optsel: taxStatus,
      transition_name: 'process_tax_status_selection',
    }),
  );
};

type CRSEvent = {
  target: {
    id: string;
    value: string;
  };
  type: string;
};

export const logCrsFieldEvents = (event: CRSEvent): void => {
  if (!event) {
    return;
  }

  const {
    target: { id, value },
    type,
  } = event;

  const payload: FptiPayload = {
    transition_name: `process_${id}_${type}`,
  };

  payload.selectedOption = value;

  logger.fpti(`crs_${id}`, getFptiPayload(payload));
};

type LogCrsErrorsParams = {
  error: string;
  field: string;
};
export const logCrsErrors = ({
  error = '',
  field,
}: LogCrsErrorsParams): void => {
  logger.fpti(
    `crs_${field}_error`,
    getFptiPayload({
      int_error_code: '1',
      int_error_desc: error,
      transition_name: `process_${field}_validation`,
    }),
  );
};

export const logAddingCrsTaxDetails = (
  totalTaxResidencies: number = 0,
): void => {
  logger.fpti('crs_add_country_and_tax_details', {
    state_name: 'crs_section',
    total_tax_residencies: totalTaxResidencies,
    transition_name: 'process_add_country_click',
  });
};

export const logRemovingCrsTaxDetails = (
  totalTaxResidencies: number = 0,
): void => {
  logger.fpti('crs_remove_country_and_tax_details', {
    state_name: 'crs_section',
    total_tax_residencies: totalTaxResidencies,
    transition_name: 'process_remove_country_click',
  });
};
